import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MenuData from "Layout/LayoutMenuData";

const VerticalLayout = (props: any) => {
  const menuData = MenuData();
  const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);
  const location = useLocation();

  const toggleDropdown = (id: string) => {
    setOpenDropdownId((prev) => (prev === id ? null : id));
  };

  const isActive = (link: string) => {
    return (
      location.pathname === link || location.pathname.startsWith(link + "/")
    );
  };

  const closeDropdown = () => {
    setOpenDropdownId(null);
  };

  // تابع بستن سایدبار هنگام کلیک روی لینک در موبایل
  const handleSubItemClick = () => {
    closeDropdown();

    if (typeof window !== "undefined") {
      const windowSize = document.documentElement.clientWidth;
      const sidebarOverlay = document.getElementById("sidebar-overlay");
      const appMenu = document.querySelector(".app-menu");

      if (windowSize < 768 && sidebarOverlay && appMenu) {
        document.body.classList.remove("overflow-hidden");
        sidebarOverlay.classList.add("hidden");
        appMenu.classList.add("hidden");
        // همچنین می‌توانید dispatch مربوطه را نیز اضافه کنید
        // dispatch(changeLeftsidebarSizeType("lg"));
      }
    }
  };

  // تابع بستن سایدبار برای لینک‌های اصلی (بدون ساب‌منو)
  const handleMainItemClick = (item: any) => {
    if (!item.subItems) {
      if (typeof window !== "undefined") {
        const windowSize = document.documentElement.clientWidth;
        const sidebarOverlay = document.getElementById("sidebar-overlay");
        const appMenu = document.querySelector(".app-menu");

        if (windowSize < 768 && sidebarOverlay && appMenu) {
          document.body.classList.remove("overflow-hidden");
          sidebarOverlay.classList.add("hidden");
          appMenu.classList.add("hidden");
          // همچنین می‌توانید dispatch مربوطه را نیز اضافه کنید
          // dispatch(changeLeftsidebarSizeType("lg"));
        }
      }
    }
  };

  return (
    <div className="sidebar-menu px-4 bg-transparent text-gray-300 rounded-lg">
      {menuData.map((item: any) => (
        <div
          key={`${item.id}_${Math.random()}`}
          className="menu-item border-b py-2 border-gray-600 border-1 last:border-b-0"
        >
          {item.subItems ? (
            <div
              onClick={() => toggleDropdown(item.id)}
              className={`flex text-sm items-center justify-between p-3 cursor-pointer transition-colors duration-200
                ${item.subItems ? "hover:bg-gray-700" : "hover:bg-gray-700"}
                ${openDropdownId === item.id ? "text-blue-400" : ""}`}
            >
              <div className="flex items-center gap-2">
                {item.icon &&
                  React.cloneElement(item.icon, {
                    className: `w-4 h-4 ${
                      isActive(item.link) ? "text-white" : "text-gray-400"
                    }`,
                  })}
                <span
                  className={`font-medium ${
                    isActive(item.link) ? "text-white" : ""
                  }`}
                >
                  {item.label}
                </span>
              </div>
              {item.subItems && (
                <span
                  className={`transform transition-transform duration-200 ${
                    openDropdownId === item.id ? "rotate-180" : ""
                  }`}
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </span>
              )}
            </div>
          ) : (
            <Link
              to={item.link}
              className={`flex text-sm items-center justify-between p-3 cursor-pointer transition-colors duration-200
                ${item.subItems ? "hover:bg-gray-700" : "hover:bg-gray-700"}
                ${openDropdownId === item.id ? "text-blue-400" : ""}`}
              onClick={() => handleMainItemClick(item)}
            >
              <div className="flex items-center gap-2">
                {item.icon &&
                  React.cloneElement(item.icon, {
                    className: `w-4 h-4 ${
                      isActive(item.link) ? "text-white" : "text-gray-400"
                    }`,
                  })}
                <span
                  className={`font-medium ${
                    isActive(item.link) ? "text-white" : ""
                  }`}
                >
                  {item.label}
                </span>
              </div>
            </Link>
          )}

          {item.subItems && openDropdownId === item.id && (
            <div className="bg-gray-750 transition-all duration-300 ease-in-out">
              {item.subItems.map((sub: any) => (
                <Link
                  key={sub.id}
                  to={sub.link}
                  className={`flex items-center py-2 px-6 pl-11 transition-colors duration-200 relative
                    ${
                      isActive(sub.link)
                        ? "text-white bg-[#2E394E] before:absolute before:right-0 before:top-1/2 before:-translate-y-1/2 before:w-1 before:h-6 before:bg-white before:rounded-l"
                        : "text-gray-400 hover:text-gray-300 hover:bg-gray-700"
                    }`}
                  onClick={handleSubItemClick}
                >
                  {sub.icon &&
                    React.cloneElement(sub.icon, {
                      className: `w-5 h-5 mr-2 ${
                        isActive(sub.link) ? "text-white" : "text-gray-500"
                      }`,
                    })}
                  <span>{sub.label}</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default VerticalLayout;
